/**
 * Store minimalista (pub/sub) para o auto-logout — v3.16.
 *
 * O hook `useAutoLogout` publica `minutes` (config do tenant) e o `lastResetAt`
 * (timestamp da última atividade). O componente `AutoLogoutBadge` lê esses
 * valores e faz uma contagem regressiva em UI.
 *
 * Separado em um módulo próprio para evitar dependência circular e permitir
 * que múltiplos componentes leiam o estado sem duplicar listeners de mouse/tecla.
 */

const listeners = new Set();

const state = {
  minutes: 0,           // 0 = auto-logoff desligado
  lastResetAt: 0,       // Date.now() da última atividade
};

export function getAutoLogoutState() {
  return state;
}

export function setAutoLogoutMinutes(m) {
  state.minutes = Number.isFinite(m) && m > 0 ? m : 0;
  emit();
}

export function markActivity() {
  state.lastResetAt = Date.now();
  emit();
}

export function subscribeAutoLogout(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function emit() {
  listeners.forEach((cb) => {
    try { cb(state); } catch { /* silent */ }
  });
}
